// Open product details inside a modal when clicking a a <ProductCard>
exports.SHOP_PDP_MODAL_ENABLED = true;

// Auto redirect authenticated users from homepage to shop discover
exports.AUTO_REDIRECT_AUTHENTICATED_TO_SHOP = false;
